import React from "react";
import { LEGAL_PATROCINADOR_CALIENTE, LEGAL_PATROCINADOR_CODERE } from "constantes/constantes";
import './legal.sass';

export default function Legal({ patrocinador }) {
    // Mapeo de patrocinadores a sus respectivos textos legales
    const legalTextMap = {
        codere: LEGAL_PATROCINADOR_CODERE,
        caliente: LEGAL_PATROCINADOR_CALIENTE
    };

    const legalText = legalTextMap[patrocinador.toLowerCase()] || "";

    return (
        <div className="container-legal" data-nosnippet>
            {legalText.trim().length > 0 && <p className="text-legal">{legalText}</p>}
        </div>
    );
}